import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import { ThemeProvider } from './lib/theme.tsx'
import './index.css'

const noCache = new URLSearchParams(window.location.search).get('nocache') === '1'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: noCache ? 0 : 5 * 60 * 1000, // 5 minutes default (bypassed with ?nocache=1)
      gcTime: noCache ? 0 : 30 * 60 * 1000,   // 30 minutes — keep cache in memory for back/forward nav
      retry: 1,
      refetchOnWindowFocus: false, // Content site: don't re-fetch on tab focus (saves API/KV reads)
      refetchOnReconnect: true,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
)
